
import type { Wine } from '../types';

export const wineList: Wine[] = [
  {
    id: 1,
    name: 'シャトー・マルゴー 2018',
    type: '赤',
    origin: 'フランス',
    variety: 'カベルネ・ソーヴィニヨン',
    price: 85000,
    taste: 'フルボディ',
    characteristics: ['カシス', 'スミレ', 'シルキーなタンニン', 'エレガント'],
    image: '',
    visible: true,
  },
  {
    id: 2,
    name: 'オーパス・ワン 2017',
    type: '赤',
    origin: 'アメリカ',
    variety: 'カベルネ・ソーヴィニヨン',
    price: 68000,
    taste: 'フルボディ',
    characteristics: ['ブラックベリー', 'カカオ', '力強い', '長い余韻'],
    image: '',
    visible: true,
  },
  {
    id: 3,
    name: 'ブルゴーニュ・シャルドネ',
    type: '白',
    origin: 'フランス',
    variety: 'シャルドネ',
    price: 4500,
    taste: '辛口',
    characteristics: ['リンゴ', '柑橘系', 'ミネラル', '樽香'],
    image: '',
    visible: true,
    isGlassWine: true,
    glassPrice: 900,
  },
  {
    id: 4,
    name: 'サンタ・マルゲリータ ピノ・グリージョ',
    type: '白',
    origin: 'イタリア',
    variety: 'ピノ・グリージョ',
    price: 2800,
    taste: '辛口',
    characteristics: ['青リンゴ', '洋梨', 'クリーン', 'フレッシュ'],
    image: '',
    visible: true,
    isGlassWine: true,
    glassPrice: 560,
  },
  {
    id: 5,
    name: 'ミラヴァル・ロゼ',
    type: 'ロゼ',
    origin: 'フランス',
    variety: 'サンソー',
    price: 3800,
    taste: '辛口',
    characteristics: ['イチゴ', 'ラズベリー', 'ハーブ', '爽やか'],
    image: '',
    visible: true,
    isGlassWine: true,
    glassPrice: 760,
  },
  {
    id: 6,
    name: 'モエ・エ・シャンドン ブリュット アンペリアル',
    type: 'スパークリング',
    origin: 'フランス',
    variety: 'ピノ・ノワール',
    price: 7200,
    taste: '辛口',
    characteristics: ['ブリオッシュ', '白い花', 'きめ細かい泡', 'バランスが良い'],
    image: '',
    visible: true,
    isGlassWine: true,
    glassPrice: 1440,
  },
  {
    id: 7,
    name: 'アルパカ・カベルネ・メルロー',
    type: '赤',
    origin: 'チリ',
    variety: 'カベルネ・メルロー',
    price: 1200,
    taste: 'ミディアムボディ',
    characteristics: ['チェリー', 'プラム', '飲みやすい', 'まろやか'],
    image: '',
    visible: true,
  },
  {
    id: 8,
    name: 'クラウディー・ベイ ソーヴィニヨン・ブラン',
    type: '白',
    origin: 'ニュージーランド',
    variety: 'ソーヴィニヨン・ブラン',
    price: 4200,
    taste: '辛口',
    characteristics: ['パッションフルーツ', 'グレープフルーツ', 'ハーブ', 'アロマティック'],
    image: '',
    visible: true,
  },
  {
    id: 9,
    name: 'カサーレ・ヴェッキオ モンテプルチャーノ・ダブルッツォ',
    type: '赤',
    origin: 'イタリア',
    variety: 'モンテプルチャーノ',
    price: 2500,
    taste: 'フルボディ',
    characteristics: ['ブラックチェリー', 'スパイス', '濃縮感', 'パワフル'],
    image: '',
    visible: true,
  },
  {
    id: 10,
    name: 'フレシネ コルドン・ネグロ ブリュット',
    type: 'スパークリング',
    origin: 'スペイン',
    variety: 'マカベオ',
    price: 1800,
    taste: '辛口',
    characteristics: ['柑橘類', 'トースト', 'キレがある', 'コストパフォーマンス'],
    image: '',
    visible: true,
  },
];

export const defaultOccasions = ['指定なし', 'お祝い・パーティー', 'ロマンチックな夜', '友人との食事', '家でリラックス', 'ギフト'];
export const defaultTastes = ['指定なし', 'フルボディ', 'ミディアムボディ', '辛口'];
export const defaultPrices = ['指定なし', '～¥5,000', '¥5,001～¥8,000', '¥8,001～'];
export const defaultOrigins = ['指定なし', 'フランス', 'アメリカ', 'イタリア', 'チリ', 'ニュージーランド', 'スペイン'];
